import { Box } from '@mui/material';
import { FullscreenRailroad } from 'pages/IssuePage/Railroad/FullscreenRailroad';
import { RailroadIssueFullPage } from 'pages/IssuePage/Railroad/RailroadIssueFullPage';
import {
  MARGIN_BETWEEN_TWO_PAGES,
  RailroadFullPage,
} from 'pages/IssuePage/Railroad/utils';
import { Options } from './DisplayOptions';
import { useMemo } from 'react';
import { useDialog } from '@prismamedia/one-components';
import { chunkArray } from 'utils/chunk-array';
import { format } from 'date-fns';

interface RailroadPagesProps {
  pages: RailroadFullPage[];
  displayOptions: Options;
  publicationDate?: string;
  comment?: string;
}

export const RailroadPages: React.FC<RailroadPagesProps> = ({
  pages,
  displayOptions,
  publicationDate,
  comment,
}) => {
  const { openDialog } = useDialog();
  const rows = useMemo(() => chunkArray(pages, displayOptions.size), [
    pages,
    displayOptions.size,
  ]);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
      }}
    >
      <Box
        sx={{
          display: 'none',
          '@media print': {
            display: 'block',
            px: 2,
            pt: 2,
            pb: 1,
            borderBottom: '1px solid #D3D3D3',
          },
        }}
      >
        {publicationDate && (
          <Box sx={{ fontSize: 14 }}>
            Date de publication : {format(new Date(publicationDate), 'P')}
          </Box>
        )}
        {comment && <Box sx={{ fontSize: 14 }}>Commentaire : {comment}</Box>}
      </Box>
      {rows.map((row, rowIndex) => (
        <Box
          key={rowIndex}
          sx={{
            display: 'flex',
            flexWrap: 'nowrap',
            p: 2,
          }}
        >
          {row.map((_, pageIndex) => {
            const fullPageIndex = rowIndex * displayOptions.size + pageIndex;
            return (
              <RailroadIssueFullPage
                key={fullPageIndex}
                pages={pages}
                pageIndex={fullPageIndex}
                displayOptions={displayOptions}
                containerSx={{
                  pr: MARGIN_BETWEEN_TWO_PAGES / 2,
                  pl: MARGIN_BETWEEN_TWO_PAGES / 2,
                  '@media print': {
                    mb: 1,
                  },
                  width: `calc(100% / ${displayOptions.size})`,
                }}
                onClick={() => {
                  openDialog(
                    <FullscreenRailroad
                      pages={pages}
                      startingIndex={fullPageIndex}
                    />,
                    {
                      fullScreen: true,
                    },
                  );
                }}
              />
            );
          })}
        </Box>
      ))}
    </Box>
  );
};
